import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'gatsby-plugin-intl';
import Layout from '../../components/layout';
import PageContentExpresso from '../../components/PageContentExpresso';

export default ({ location }) => {
  const intl = useIntl();

  return (
    <Layout location={location}>
      <Helmet bodyAttributes={{ class: 'page-template page-template-page-expresso page-template-page-expresso-php page page-id-284 full-width custom-font-enabled single-author mob-menu-slideout' }}>
        <title>{intl.formatMessage({ id: 'Catálogo Personalizado | Ideia 2001' })}</title>
      </Helmet>

      <div id="primary" className="site-content">
        <PageContentExpresso
          titulo={intl.formatMessage({ id: 'Catálogo Personalizado' })}
          Conteudo={() => (
            <>
              <p>{intl.formatMessage({ id: 'O' })} <strong>{intl.formatMessage({ id: 'Catálogo Personalizado' })}</strong> {intl.formatMessage({ id: 'é totalmente desenvolvido de acordo com os objetivos do cliente' })}.</p>
              <p>{intl.formatMessage({ id: 'Apresentando design exclusivo, qualquer possibilidade de pesquisa, vistas explodidas interativas com informações, fotos dos produtos, módulo de impressão, apresentações institucionais, cadastro de clientes, carrinho de compras, informativos, fale conosco, opção multi-idioma, ajuda visual e tudo mais que o cliente determinar' })}.</p>
              <p>{intl.formatMessage({ id: 'Todos nossos catálogos acompanham um' })} <strong>{intl.formatMessage({ id: 'Software de Manutenção' })}</strong> {intl.formatMessage({ id: 'que possibilita a manutenção total do catálogo tornando nossos clientes completamente independentes' })}.</p>
            </>
          )}
        />
      </div>
    </Layout>
  );
};
